/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Step_2_TitleInputs */

const en_mk_tb_step_2_title = /** @type {(inputs: Mk_Tb_Step_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work with your own AI`)
};

const id_mk_tb_step_2_title = /** @type {(inputs: Mk_Tb_Step_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerjakan dengan AI masing-masing`)
};

/**
* | output |
* | --- |
* | "Work with your own AI" |
*
* @param {Mk_Tb_Step_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_step_2_title = /** @type {((inputs?: Mk_Tb_Step_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Step_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_step_2_title(inputs)
	return en_mk_tb_step_2_title(inputs)
});